<button
  class="mc-nav-item"
  [ngClass]="{'mc-nav-item_active': isActive, 'mc-nav-item_with-icon': icon}"
  [routerLink]="link"
  (click)="onNavigate()"
  data-testid="nav-item-button"
>
  <div class="mc-nav-item-wrap">
    @if (icon) {
      <mat-icon
        class="mc-nav-item__icon"
        svgIcon="{{ isActive && iconActive ? iconActive : icon }}"
        aria-hidden="true"
      ></mat-icon>
    }
    <span class="mc-nav-item__label">
      <span class="mc-nav-item__label__text" [innerHTML]="label"></span>
    </span>
  </div>

  @if (labelIcon) {
    <mat-icon
      svgIcon="{{ isActive ? labelIconActive : labelIcon }}"
      class="mc-nav-item__label-icon"
      aria-hidden="true"
    ></mat-icon>
  }
</button>
